import { render, staticRenderFns } from "./BoardArticleRead.vue?vue&type=template&id=040eaea1&scoped=true&"
import script from "./BoardArticleRead.vue?vue&type=script&lang=ts&"
export * from "./BoardArticleRead.vue?vue&type=script&lang=ts&"
import style0 from "./BoardArticleRead.vue?vue&type=style&index=0&id=040eaea1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040eaea1",
  null
  
)

export default component.exports